export default "__VITE_ASSET__BbqB7Mqn__"